/* eslint no-console: "off" */
import SockJS from 'sockjs-client';
import Stomp from 'stompjs';

let gameStompClient = null;
let notificationsStompClient = null;
let onlineChannelStompClient = null;
let chatStompClient = null;

const createNewStompClient = (path) => {
  console.log('creating a new web socket client');
  const newGameSocket = new SockJS(path);
  console.log('newGameSocket');
  console.log(newGameSocket);
  const stompClient = Stomp.over(newGameSocket);
  if (path === '/gameData') {
    gameStompClient = stompClient;
  } else if (path === '/notificationsData') {
    notificationsStompClient = stompClient;
  } else if (path === '/onlineChannel') {
    onlineChannelStompClient = stompClient;
  } else if (path === '/messaging') {
    chatStompClient = stompClient;
  }
  // TODO uncomment following line in live builds in order to disable/remove debug messages
  stompClient.debug = null;
  console.log(stompClient);
  return stompClient;
};

const getGameStompClient = () => gameStompClient;
const getNotificationsStompClient = () => notificationsStompClient;
const getOnlineChannelStompClient = () => onlineChannelStompClient;
const getChatStompClient = () => chatStompClient;

/* eslint-disable */
const disconnectGameStompClient = () => {
  if (gameStompClient !== null) {
    gameStompClient.disconnect();
    gameStompClient = null;
  }
};
const disconnectNotificationsStompClient = () => {
  if (notificationsStompClient !== null) {
    notificationsStompClient.disconnect();
    notificationsStompClient = null;
  }
};
const disconnectOnlineStompClient = () => {
  if (onlineChannelStompClient !== null) {
    onlineChannelStompClient.disconnect();
    onlineChannelStompClient = null;
  }
};
const disconnectChatStompClient = () => {
  if (chatStompClient !== null) {
    chatStompClient.disconnect();
    chatStompClient = null;
  }
};

export default {
  createNewStompClient,
  getGameStompClient,
  getNotificationsStompClient,
  getOnlineChannelStompClient,
  getChatStompClient,
  disconnectGameStompClient,
  disconnectNotificationsStompClient,
  disconnectOnlineStompClient,
  disconnectChatStompClient
};



// WEBPACK FOOTER //
// ./src/common/webSocket.js